<template>
    <div class="p-md">
        <div class="app-block p-md m-b-md">
        <div v-if="application.accepted || application.registration_complete">
            <h3 class="heading-line title is-4 has-text-weight-light">
                <span>Vos documents:</span>
            </h3>

            <div v-if="application.accepted && !registeredCandidate()">
                <a :href="'/admissible/doc/' + application.id" title="Confirmation de pré-inscription">
                Confirmation de pré-inscription (admissibilité)</a>
            </div>

            <div v-if="application.registration && application.registration.registration_payment_mode === 'BANK-CHECK'">

                <a :href="'/inscription/doc/' + application.id" title="Offre de facilité de paiement">
                Offre de facilité de paiement</a>
            </div>

            <div v-if="application.registration && application.registration.registration_accepted">

                <a :href="'/contrat/doc/' + application.id" title="Contrat de scolarité"
                >
                Contrat de scolarité</a>
            </div>

            <div v-if="application.registration && application.registration.registered_candidate">

                <a :href="'/admission/doc/' + application.id" title="Confirmation d'inscription"
                >
                Confirmation d'inscription</a>
                <br>
                <a :href="'/certificat/doc/' + application.id" title="Certificat de scolarité">
                    Certificat de scolarité
                </a>
            </div>

        </div>
        </div>
    </div>

</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters({
                account: 'auth/getAccount'
            }),
            ...mapGetters('organization', [
                'currentScholarYear'
            ]),
        },
        props: {
            candidate: {type: Object},
            application: {type: Object},
        },
        methods: {
            formatDate (date) {
                return window.moment(date.date).format('LLL');
            },
            registeredCandidate() {
                return this.candidate && this.candidate.hasRegisteredApplication
            }
        }
    }
</script>

<style scoped>

</style>
